import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import Layout from '../../layout'

export const PageNotFound: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Layout>
      <div className="flex flex-col justify-center flex-1 items-center gap-10 p-5">
        <img
          src="/assets/images/error-page-svgrepo-com.svg"
          alt="404"
          className="max-w-[200px]"
        />

        <div className="flex flex-col gap-1 items-center">
          <p className="text-2xl font-recoleta font-medium">
            You’ve Reached a Dead End 💀
          </p>

          <p className="text-sec-black max-w-[550px] text-center">
            The page you’re trying to access isn’t available. It may have been
            moved, renamed, or removed. Let’s get you back on track.
          </p>
        </div>

        <Button
          type="button"
          label="Go home"
          className="w-full max-w-[300px]"
          primary={true}
          onClick={() => {
            navigate('/dashboard')
          }}
        />
      </div>
    </Layout>
  )
}
